import { Duration, DateTime } from "luxon";

const convert = (amount, unit) => (amount > 0 ? amount + unit : "");

export const DateHelper = {
  getFancyTimeFormat(seconds, disableSeconds = false) {
    const duration = Duration.fromMillis(seconds * 1000)
      .shiftTo("hours", "minutes", "seconds")
      .toObject();

    let add_m = false;
    let add_h = false;

    let s = Math.round(duration.seconds);
    if (s === 60) {
      s = 0;
      add_m = true;
    }

    let m = duration.minutes + (add_m ? 1 : 0);
    if (m === 60) {
      m = 0;
      add_h = true;
    }

    const h = duration.hours + (add_h ? 1 : 0);

    return [convert(h, "h"), convert(m, "m"), !disableSeconds ? convert(s, "s") : ""]
      .filter(Boolean)
      .join(" ");
  },

  getFancyDaysTimeFormat(seconds) {
    const duration = Duration.fromMillis(seconds * 1000)
      .shiftTo("days", "hours", "minutes", "seconds")
      .toObject();

    let add_m = false;
    let add_h = false;
    let add_d = false;

    let s = Math.round(duration.seconds);
    if (s === 60) {
      s = 0;
      add_m = true;
    }

    let m = duration.minutes + (add_m ? 1 : 0);
    if (m === 60) {
      m = 0;
      add_h = true;
    }

    let h = duration.hours + (add_h ? 1 : 0);
    if (h === 24) {
      h = 0;
      add_d = true;
    }

    const d = duration.days + +(add_d ? 1 : 0);

    return [convert(d, "d"), convert(h, "h"), convert(m, "m"), convert(s, "s")]
      .filter(Boolean)
      .join(" ");
  },
  getFancyTimeHHMMSS(s) {
    return s > 0 ? new Date(s * 1000).toUTCString().match(/(\d\d:\d\d:\d\d)/)[0] : 0;
  },
  getListOfTimezones() {
    return [
      {
        value: "-12:00",
        label: "GMT-12 International Date Line West (IDLW)"
      },
      {
        value: "-11:00",
        label: "GMT-11 Nome Time (NT)"
      },
      {
        value: "-10:00",
        label: "GMT-10 Hawaii Standard Time (HST)"
      },
      {
        value: "-09:00",
        label: "GMT-09 Alaska Standard Time (AKST)"
      },
      {
        value: "-08:00",
        label: "GMT-08 Pacific Standard Time (PST)"
      },
      {
        value: "-07:00",
        label: "GMT-07 Mountain Standard Time (MST)"
      },
      {
        value: "-06:00",
        label: "GMT-06 Central Standard Time (CST)"
      },
      {
        value: "-05:00",
        label: "GMT-05 Eastern Standard Time (EST)"
      },
      {
        value: "-04:00",
        label: "GMT-04 Atlantic Standard Time (AST)"
      },
      {
        value: "-03:00",
        label: "GMT-03 Argentina Time (ART)"
      },
      {
        value: "-02:00",
        label: "GMT-02 Azores Time (AT)"
      },
      {
        value: "-01:00",
        label: "GMT-01 West Africa Time (WAT)"
      },
      {
        value: "+00:00",
        label: "GMT+00 Greenwich Mean Time (GMT)"
      },
      {
        value: "+01:00",
        label: "GMT+01 Central European Time (CET)"
      },
      {
        value: "+02:00",
        label: "GMT+02 Eastern European Time (EET)"
      },
      {
        value: "+03:00",
        label: "GMT+03 Moscow Time (MSK)"
      },
      {
        value: "+04:00",
        label: "GMT+04 Armenia Time (AMT)"
      },
      {
        value: "+05:00",
        label: "GMT+05 Pakistan Standard Time (PKT)"
      },
      {
        value: "+06:00",
        label: "GMT+06 Omsk Time (OSMK)"
      },
      {
        value: "+07:00",
        label: "GMT+07 Kranoyask Time (KRAT)"
      },
      {
        value: "+08:00",
        label: "GMT+08 China Standard Time (CST)"
      },
      {
        value: "+09:00",
        label: "GMT+09 Japan Standard Time (JST)"
      },
      {
        value: "+10:00",
        label: "GMT+10 Eastern Australia Standard Time (AEST)"
      },
      {
        value: "+11:00",
        label: "GMT+11 Sakhalin Time (SAKT)"
      },
      {
        value: "+12:00",
        label: "GMT+12 New Zealand Standard Time (NZST)"
      }
    ];
  },
  formatTimeWithoutSeconds(timestamp, lang = "en") {
    let result = "-";
    try {
      if (timestamp) {
        result = DateTime.fromJSDate(new Date(timestamp))
          .setLocale(lang)
          .toLocaleString(DateTime.TIME_SIMPLE);
      }
    } catch (e) {
      result = "-";
    }
    return result;
  },
  formatTimeWithSeconds(timestamp, lang = "en") {
    let result = "-";

    try {
      if (timestamp) {
        result = DateTime.fromJSDate(new Date(timestamp))
          .setLocale(lang)
          .toLocaleString(DateTime.TIME_WITH_SECONDS);
      }
    } catch (e) {
      result = "-";
    }

    return result;
  }
};
